import addError from '../../../utils/error.jsx';
import { bulk } from './update';

export function request( eventId, marketId, data ) {
    return {
        type: 'MARKETS_MOVE_SELECTION_REQUEST',
        eventId,
        marketId,
        data
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'MARKETS_MOVE_SELECTION_ERROR',
        errors
    };
}

export function finish(data) {
    return (dispatch) => {
        dispatch(bulk(data));

        dispatch({
            type: 'MARKETS_MOVE_SELECTION_FINISH',
            data
        });
    };
}
